import {ArrowRight} from 'lucide-react';
import { Link } from 'react-router-dom';
import Seo from '@/components/Seo';
import { courses, getInstructor, heroImage, instructors } from '@/data/catalog';

function Home() {
  return (
    <>
      <Seo
        title="HFCursos · Escuela de oficio"
        description="Plataforma de cursos HFCursos: identidad, fotografía y liderazgo. Catálogo, inscripciones, aula con presentaciones y certificados." />

      <section className="relative mx-auto grid max-w-6xl gap-10 overflow-hidden px-5 py-12 sm:py-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-end lg:gap-14 lg:px-8 lg:py-24">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-[#C41E3A]/15 sm:h-80 sm:w-80" />

        <div
          aria-hidden="true"
          className="pointer-events-none absolute -bottom-16 left-1/3 hidden h-40 w-40 rounded-full bg-[#1E3A5F]/15 lg:block" />

        <div className="relative">
          <p className="inline-flex items-center gap-2 rounded-full border border-[#1E3A5F]/25 bg-[#1E3A5F]/10 px-4 py-1.5 text-xs uppercase tracking-[0.28em] text-[#1E3A5F] font-medium sm:text-sm">
            <span className="h-1.5 w-1.5 rounded-full bg-[#C41E3A]" />
            Escuela virtual
          </p>
          <h1 className="mt-5 max-w-xl font-['Fraunces'] text-4xl leading-[1.08] sm:text-5xl md:text-6xl lg:text-7xl">
            Aprender a <span className="text-[#C41E3A]">cualquier hora</span>
          </h1>
          <p className="mt-6 max-w-md text-base leading-relaxed text-[#1E3A5F]/70 sm:text-lg">
            Programas breves con un certificado al terminar (emitido por el COMEII).
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Link
              to="/cursos"
              className="inline-flex items-center justify-center gap-2 bg-[#1E3A5F] px-6 py-3.5 text-sm font-medium text-white transition-colors hover:bg-[#C41E3A] sm:justify-start">

              Ver el catálogo
              <ArrowRight size={16} aria-hidden="true" />
            </Link>
            <Link
              to="/instructores"
              className="inline-flex items-center justify-center gap-2 border border-[#C41E3A]/40 px-6 py-3.5 text-sm text-[#C41E3A] underline-offset-4 transition-colors hover:border-[#C41E3A] hover:bg-[#C41E3A]/5 hover:underline sm:justify-start">

              Conocer al equipo
            </Link>
          </div>
          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-[#1E3A5F]/15 pt-6 sm:max-w-md">
            <div>
              <dt className="sr-only">Cursos disponibles</dt>
              <dd className="font-['Fraunces'] text-2xl sm:text-3xl">{courses.length}+</dd>
              <p className="mt-1 text-[11px] uppercase tracking-wide text-[#1E3A5F]/50 sm:text-xs">Cursos</p>
            </div>
            <div>
              <dt className="sr-only">Instructores</dt>
              <dd className="font-['Fraunces'] text-2xl sm:text-3xl">{instructors.length}</dd>
              <p className="mt-1 text-[11px] uppercase tracking-wide text-[#1E3A5F]/50 sm:text-xs">Instructores</p>
            </div>
            <div>
              <dt className="sr-only">Certificación</dt>
              <dd className="font-['Fraunces'] text-2xl sm:text-3xl">100%</dd>
              <p className="mt-1 text-[11px] uppercase tracking-wide text-[#1E3A5F]/50 sm:text-xs">Certificado</p>
            </div>
          </dl>
        </div>
        <figure className="relative">
          <div className="absolute -inset-3 -z-10 hidden rotate-1 bg-[#1E3A5F]/20 sm:block" aria-hidden="true" />
          <img
            src={heroImage}
            alt="Mesa de estudio con cuadernos, café y luz de ventana"
            className="h-[280px] w-full object-cover shadow-sm sm:h-[380px] lg:h-[460px]" />

          <figcaption className="absolute bottom-0 left-0 flex items-center gap-3 bg-[#C41E3A] px-4 py-3 text-white sm:px-5 sm:py-4">
            <span className="font-['Fraunces'] text-xl sm:text-2xl">HFCursos</span>
            
          </figcaption>
        </figure>
      </section>

      <section className="border-y border-[#1E3A5F]/10 bg-[#1E3A5F]/5">
        












      </section>

      <section className="mx-auto max-w-6xl px-5 py-16 lg:px-8">
        <div className="flex items-end justify-between gap-4">
          <h2 className="font-['Fraunces'] text-3xl">Cursos abiertos</h2>
          <Link to="/cursos" className="text-sm underline-offset-4 hover:underline">
            Catálogo completo
          </Link>
        </div>
        <div className="mt-8 grid gap-8 md:grid-cols-2">
          {courses.slice(0, 4).map((course) => {
            const instructor = getInstructor(course.instructorId);
            return (
              <article key={course.id} className="group">
                <Link to={`/cursos/${course.slug}`} className="block">
                  <img
                    src={course.image}
                    alt=""
                    className="h-56 w-full object-cover transition duration-500 group-hover:brightness-95" />

                  <p className="mt-4 text-xs uppercase tracking-[0.2em] text-[#C41E3A]">{course.category}</p>
                  <h3 className="mt-1 font-['Fraunces'] text-2xl">{course.title}</h3>
                  <p className="mt-2 text-sm text-[#1E3A5F]/65">{course.excerpt}</p>
                  <p className="mt-3 text-xs text-[#1E3A5F]/50">
                    {instructor?.name} · {course.duration} · {course.level}
                  </p>
                </Link>
              </article>);

          })}
        </div>
      </section>

      <section className="bg-[#1E3A5F] text-white">
        <div className="mx-auto grid max-w-6xl gap-10 px-5 py-16 lg:grid-cols-[0.8fr_1.2fr] lg:px-8">
          <div>
            <h2 className="font-['Fraunces'] text-3xl">Quién enseña</h2>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/70">.

            </p>
          </div>
          <ul className="grid gap-6 sm:grid-cols-3">
            {instructors.map((person) =>
            <li key={person.id}>
                <Link to="/instructores" className="block">
                  <img src={person.photo} alt={`Retrato de ${person.name}`} className="aspect-[3/4] w-full object-cover" />
                  <p className="mt-3 font-['Fraunces'] text-lg">{person.name}</p>
                  <p className="text-xs text-[#C41E3A]">{person.role}</p>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </section>
    </>);

}

export default Home;